export const eForm = {
    "eFormSet": {
        "eFormSet01": "表單類型",
        "eFormSet02": "有效日期",
        "eFormSet03": "表單應用單位",
        "eFormSet04": "表單名稱",
        "eFormSet05": "表單代碼",
        "eFormSet06": "表單使用流程",
        "eFormSet07": "備註",
        "eFormSet08": "表單設定-新增",
        "eFormSet09": "表單設定-修改",
    },
    "eForm": {
        "eForm01": "表單",
        "eForm02": "表單類型",
        "eForm03": "表單代碼",
        "eForm04": "填寫時間",
        "eForm05": "填寫表單資料",
        "eForm06": "送出流程作業，確定嗎?",
        "eForm07": "表單使用流程",
        "eForm08": "表單填寫-送出流程",
        "eForm09": "表單填寫-新增",
        "eForm10": "表單填寫-修改",
    },
    "eFormFlow": {
        "eFormFlow01": "表單類型",
        "eFormFlow02": "表單代碼",
        "eFormFlow03": "剩餘簽核天數",
        "eFormFlow04": "確定要進行簽核作業嗎？",
        "eFormFlow05": "表單簽核-修改",
        "eFormFlow06": "提供意見",
        "eFormFlow07": "簽核同意",
        "eFormFlow08": "簽核退回",
        "eFormFlow09": "分會啟動",
        "eFormFlow10": "簽核意見必填",
        "eFormFlow11": "同意",
        "eFormFlow12": "退回",
        "eFormFlow13": "分會",
        "eFormFlow14": "流程編號",
        "eFormFlow15": "分會流程編號",
        "eFormFlow16": "是否為分會",
        "eFormFlow17": "否",
        "eFormFlow18": "是"
    }
}